import * as types from "../actions/actionTypes";
import initialState from "../store/initialState";

export default function indienenReducer(state = initialState.indienen, action) {
	switch (action.type) {
		case types.INDIENEN_LOADED: {
			return Object.assign({}, action.body);
		}

		case types.INDIENEN_SAVED: {
			return Object.assign({}, action.body);
		}

		default:
			return state;
	}
}
